function initializeBeanies(){
  document.querySelectorAll('[data-beanie]').forEach(root=>{
    if(root.dataset.initialized)return;
    const select=root.querySelector('[data-beanie-select]');
    const img=root.querySelector('img.mainpic');
    const slide=img?frozenSlider(img):null;
    function sync(updateURL){
      const option=select.selectedOptions[0];
      root.querySelectorAll('[data-beanie-choice]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.beanieChoice===select.value)));
      const available=!!option&&option.dataset.available==='true';
      root.querySelector('[data-beanie-add]').disabled=!available;
      root.querySelector('[data-beanie-add]').textContent=available?'ADD TO CART':'SOLD OUT';
      root.querySelector('[data-beanie-express]').hidden=!available;
      if(!option)return;
      const selectedLabel=root.querySelector('[data-beanie-selected]');
      if(selectedLabel){const clean=option.textContent.replace(/\s+—\s+Sold out\s*$/i,'').trim();selectedLabel.textContent=clean.split('/').pop().replace(/^one\s*size[^a-z0-9]*/i,'').trim();}
      root.querySelector('[data-beanie-price]').textContent=option.dataset.price;
      if(slide&&option.dataset.image){img.removeAttribute('srcset');slide(option.dataset.image,option.textContent.trim());}
      if(updateURL){const url=new URL(location.href);url.searchParams.set('variant',option.value);history.replaceState({},'',url);}
    }
    select.addEventListener('change',()=>sync(true));
    root.querySelectorAll('[data-beanie-choice]').forEach(b=>b.addEventListener('click',()=>{select.value=b.dataset.beanieChoice;select.dispatchEvent(new Event('change',{bubbles:true}));}));
    root.querySelectorAll('[data-beanie-photo]').forEach(link=>link.addEventListener('click',event=>{if(slide){event.preventDefault();img.removeAttribute('srcset');slide(link.href,link.querySelector('img').alt);}}));
    root.querySelector('form').addEventListener('submit',event=>{if(!select.selectedOptions[0]||select.selectedOptions[0].dataset.available!=='true')event.preventDefault();});
    root.dataset.initialized='true';sync(false);
  });
}
document.addEventListener('DOMContentLoaded',initializeBeanies);
document.addEventListener('shopify:section:load',initializeBeanies);
